import { useTheme, useMediaQuery } from "@mui/material";
import DashboardMobile from "./DashboardMobile";
import DashboardDesktop from "./DashboardDesktop";

export default function Dashboard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <DashboardMobile /> : <DashboardDesktop />;
}
